import "./BabyTracker.css";

const BabyTrackerLoading = ({ label = "Loading baby tracker" }) => (
  <div className="BabyTrackerCorgiLoader" role="status" aria-live="polite">
    <span className="BabyTrackerScreenReaderOnly">{label}</span>
    <div className="BabyTrackerCorgiTrack" aria-hidden="true">
      <div className="BabyTrackerCorgi">
        <span className="BabyTrackerCorgiEar BabyTrackerCorgiEarLeft"></span>
        <span className="BabyTrackerCorgiEar BabyTrackerCorgiEarRight"></span>
        <span className="BabyTrackerCorgiHead"></span>
        <span className="BabyTrackerCorgiSnout"></span>
        <span className="BabyTrackerCorgiBody"></span>
        <span className="BabyTrackerCorgiChest"></span>
        <span className="BabyTrackerCorgiTail"></span>
        <span className="BabyTrackerCorgiLeg BabyTrackerCorgiLegOne"></span>
        <span className="BabyTrackerCorgiLeg BabyTrackerCorgiLegTwo"></span>
        <span className="BabyTrackerCorgiLeg BabyTrackerCorgiLegThree"></span>
        <span className="BabyTrackerCorgiLeg BabyTrackerCorgiLegFour"></span>
      </div>
    </div>
  </div>
);

export default BabyTrackerLoading;
